






import {ISearchSettings} from '@/apps/SearchWidget/models/search-settings-model';
import {IDictionary} from '@/shared/models/interface/dictionary-model';
import {IFixedFilter} from '@/shared/models/view/fixed-filter-model';
import IFilterGroup from '@/apps/SearchWidget/models/filter-group-model';
import IScopeLink from '@/apps/SearchWidget/models/scope-links-model';

import Scientists from './Scientists/Scientists.vue';
import VUSearch from './VU/VUSearch.vue';
import {defineComponent, onMounted, PropType, watch} from "@vue/composition-api";
import {useActions, useGetters, useState} from "vuex-composition-helpers";
import {watchDebounced} from "@vueuse/core";

export default defineComponent({
  name: "SearchWidget",
  components: {
    Scientists,
    VUSearch
  },
  props: {
    searchSettings: {type: Object as PropType<ISearchSettings>},
    fixedFilters: {type: Object as PropType<IDictionary<IFixedFilter>>},
    userFilters: {type: Array as PropType<IFilterGroup[]>},
    userFilterOverride: {type: Object as PropType<IDictionary<IFilterGroup[]>>},
    scopeFilter: {type: Object as PropType<IFilterGroup>},
    scopeLinks: {type: Array as PropType<IScopeLink[]>},
    imageFallback: {type: String},
    query: {type: String}
  },
  setup: (props) => {
    const {componentType} = useGetters(['componentType'])
    const {loadData, init} = useActions(['loadData', 'init'])
    const {activeScopeItems} = useState('scope', ['activeScopeItems'])
    const {activeFilterItems} = useState('filter', ['activeFilterItems'])
    const {config, isInitialized, searchQuery} = useState(['config', 'isInitialized', 'searchQuery'])

    watch(activeFilterItems, () => {
      if (isInitialized.value) {
        loadData([false]);
      }
    })

    watch(activeScopeItems, () => {
      if (isInitialized.value) {
        loadData([false]);
      }
    })

    watchDebounced(searchQuery, () => {
          if (isInitialized.value) {
            loadData([false]);
          }
        }, {
          debounce: 500,
          maxWait: 2500
        }
    )

    onMounted(() => {
      init(props);
    })

    return {
      config,
      componentType
    }
  }
})
